// ========================================
// ================== V3 ==================
// ========================================

import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";

const initialState = {
  tasks: null,
  tasks_error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.V3_TASKS_SET:
      return fetchTasksSet(state, action);
    case aTypes.V3_TASKS_FETCH_FAIL:
      return fetchTasksSetFail(state, action);
    case aTypes.V3_TASKS_RESET:
      console.log("Resetting tasks state");
      return updateObject(state, { tasks: null, tasks_error: null });
    default:
      return state;
  }
};

const fetchTasksSet = (state, action) => {
  return updateObject(state, {
    tasks: action.tasks,
  });
};

const fetchTasksSetFail = (state, action) => {
  return updateObject(state, {
    tasks_error: action.error,
  });
};

export default reducer;
